import { gql } from '@apollo/client';
import { MATERIAL_TEMPLATE_FIELDS } from './fragments';

// ============================================================================
// Queries
// ============================================================================

export const MATERIAL_TEMPLATE_LABELS_QUERY = gql`
  query MaterialTemplateLabels($allCustomers: Boolean, $customerNumbers: [String!]) {
    materialTemplateLabels(allCustomers: $allCustomers, customerNumbers: $customerNumbers) {
      name
      color
      sortOrder
    }
  }
`;

// ============================================================================
// Mutations
// ============================================================================

export const ASSIGN_TEMPLATE_LABEL_MUTATION = gql`
  mutation AssignTemplateLabel($templateIds: [ID!]!, $label: String!, $customerNumber: String) {
    assignTemplateLabel(templateIds: $templateIds, label: $label, customerNumber: $customerNumber) {
      ...MaterialTemplateFields
    }
  }
  ${MATERIAL_TEMPLATE_FIELDS}
`;

export const REMOVE_TEMPLATE_LABEL_MUTATION = gql`
  mutation RemoveTemplateLabel($templateIds: [ID!]!, $label: String!, $customerNumber: String) {
    removeTemplateLabel(templateIds: $templateIds, label: $label, customerNumber: $customerNumber) {
      ...MaterialTemplateFields
    }
  }
  ${MATERIAL_TEMPLATE_FIELDS}
`;

export const CREATE_MATERIAL_TEMPLATE_LABEL_MUTATION = gql`
  mutation CreateMaterialTemplateLabel($name: String!, $color: String, $customerNumber: String) {
    createMaterialTemplateLabel(name: $name, color: $color, customerNumber: $customerNumber) {
      name
      color
      sortOrder
    }
  }
`;

export const RENAME_MATERIAL_TEMPLATE_LABEL_MUTATION = gql`
  mutation RenameMaterialTemplateLabel($oldName: String!, $newName: String!, $customerNumber: String) {
    renameMaterialTemplateLabel(oldName: $oldName, newName: $newName, customerNumber: $customerNumber) {
      name
      color
      sortOrder
    }
  }
`;

export const UPDATE_MATERIAL_TEMPLATE_LABEL_COLOR_MUTATION = gql`
  mutation UpdateMaterialTemplateLabelColor($name: String!, $color: String, $customerNumber: String) {
    updateMaterialTemplateLabelColor(name: $name, color: $color, customerNumber: $customerNumber) {
      name
      color
      sortOrder
    }
  }
`;

export const REORDER_MATERIAL_TEMPLATE_LABELS_MUTATION = gql`
  mutation ReorderMaterialTemplateLabels($orderedNames: [String!]!, $customerNumber: String) {
    reorderMaterialTemplateLabels(orderedNames: $orderedNames, customerNumber: $customerNumber) {
      name
      color
      sortOrder
    }
  }
`;

export const DELETE_MATERIAL_TEMPLATE_LABEL_MUTATION = gql`
  mutation DeleteMaterialTemplateLabel($name: String!, $customerNumber: String) {
    deleteMaterialTemplateLabel(name: $name, customerNumber: $customerNumber)
  }
`;
